module.exports = __webpack_public_path__ + "img/2.0008c763.png";